<script setup>
    defineProps({
        color : {
            type : String,
            default : "white"
        }
    })
</script>
<template>
    <svg viewBox="0 0 60 20" width="60" height="16" :style="{ color }" preserveAspectRatio="xMidYMid meet">
        <circle cx="10" cy="10" r="4" fill="currentColor">
            <animate attributeName="opacity" dur="1s" values="0.2;1;0.2" repeatCount="indefinite" begin="0s" />
        </circle>

        <circle cx="30" cy="10" r="4" fill="currentColor">
            <animate attributeName="opacity" dur="1s" values="0.2;1;0.2" repeatCount="indefinite" begin="0.2s" />
        </circle>

        <circle cx="50" cy="10" r="4" fill="currentColor">
            <animate attributeName="opacity" dur="1s" values="0.2;1;0.2" repeatCount="indefinite" begin="0.4s" />
        </circle>
    </svg>
</template>